// extracted by mini-css-extract-plugin
module.exports = {"feedback":"feedback-item-feedback--4ac15","title":"feedback-item-title--e1e13"};